export const BASE_URL = "https://ecommerce-j6lp.onrender.com";
// export const BASE_URL = "http://localhost:3001";
